import { EmptyState } from "@shopify/polaris";
import React from "react";
import { useTranslation } from "react-i18next";

export function PolarisEmptyState() {
  const { t } = useTranslation();
  return (
    <EmptyState
      heading={t("no_records")}
      image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
    >
      <p>{t("no_record_desc")}</p>
    </EmptyState>
  );
}
